import React, { useState, useContext, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { Typography, Grid, Divider, Tooltip } from "@mui/material"
import ChatTwoToneIcon from "@mui/icons-material/ChatTwoTone"
import SearchTwoToneIcon from "@mui/icons-material/SearchTwoTone"
import ActivePositionItem from "./ActivePositionItem"
import ActivePositionDialog from "./ActivePositionDialog"
import BackdropContext from "../../../context/BackdropContext"
import useMutation from "../../../hooks/useMutation"
import { F_TRADING_CHAT } from "../../../constants/routes"
import StateContext from "../../../context/StateContext"

const ActivePositions = ({ isMobile, setSnackbarMsg }) => {
  const navigate = useNavigate()
  const goToChat = () => navigate(F_TRADING_CHAT)

  const { backdropOpen, openBackdrop, closeBackdrop } = useContext(BackdropContext)

  const [currentAP, setCurrentAP] = useState(null)

  const { mutate: cancelMutation, loading: cancelLoading } = useMutation("/ledger", "DELETE")
  // const { data: ledgerList, loading: ledgerLoading, refetch: ledgerRefetch } = useFetch(`/ledger/user/${userId}`)
  const { ledgerList, ledgerLoading, ledgerRefetch } = useContext(StateContext)

  const loading = ledgerLoading || cancelLoading

  useEffect(() => {
    if (loading) {
      openBackdrop()
    } else {
      if (backdropOpen) {
        closeBackdrop()
      }
    }
  }, [loading, openBackdrop, backdropOpen, closeBackdrop])

  const searchBuy = ledgerLoading ? [] : ledgerList.filter((e) => e.status === "search" && e.action === "buy")
  const searchSell = ledgerLoading ? [] : ledgerList.filter((e) => e.status === "search" && e.action === "sell")
  const matchedBuy = ledgerLoading ? [] : ledgerList.filter((e) => e.status === "matched" && e.action === "buy")
  const matchedSell = ledgerLoading ? [] : ledgerList.filter((e) => e.status === "matched" && e.action === "sell")

  const handleCancel = async () => {
    if (currentAP) {
      try {
        await cancelMutation({
          ...currentAP, // just for backend validation
          id: currentAP.id, // only these fields are really needed
          partnerId: currentAP.partnerId,
        })

        ledgerRefetch()

        setSnackbarMsg(currentAP.action === "buy" ? "Kauf abgebrochen" : "Verkauf abgebrochen")
      } catch (e) {
        console.log(e.message)
      }

      setCurrentAP(null)
    }
  }

  return (
    <>
      <Typography
        variant="h5"
        align={isMobile ? "center" : "left"}
        sx={{ color: "secondary.main", ml: "1vw", pt: "1vw", width: isMobile ? "96vw" : "auto", mb: isMobile ? 4 : 0 }}>
        Meine Bücher
      </Typography>

      <Grid container justifyContent="space-evenly" sx={{ height: "auto", mt: "5vh" }}>
        <Grid item xs={5.9}>
          <Typography variant="subtitle1" align="center">
            Kaufen
          </Typography>
          <Typography variant="subtitle2" align="center" sx={{ mt: "1vh" }}>
            Partner wird gesucht
          </Typography>
          {searchBuy.map((row) => (
            <ActivePositionItem
              isMobile={isMobile}
              icon={
                <Tooltip arrow placement="top" title="Partner wird gesucht...">
                  <SearchTwoToneIcon sx={{ verticalAlign: "bottom" }} />
                </Tooltip>
              }
              setCurrentAP={setCurrentAP}
              key={row.id}
              details={row}
            />
          ))}
          <Divider sx={{ mt: "3vh", width: "90%", mx: "5%" }} />
          <Typography variant="subtitle2" align="center" sx={{ mt: "1vh" }}>
            Partner gefunden
          </Typography>
          {matchedBuy.map((row) => (
            <ActivePositionItem
              isMobile={isMobile}
              icon={
                <Tooltip arrow placement="top" title="Partner gefunden">
                  <ChatTwoToneIcon sx={{ color: "primary.main", verticalAlign: "bottom" }} />
                </Tooltip>
              }
              setCurrentAP={setCurrentAP}
              key={row.id}
              details={row}
            />
          ))}
        </Grid>
        <Grid item xs={0.2}>
          <Divider orientation="vertical" />
        </Grid>
        <Grid item xs={5.9}>
          <Typography variant="subtitle1" align="center">
            Verkaufen
          </Typography>

          <Typography variant="subtitle2" align="center" sx={{ mt: "1vh" }}>
            Partner wird gesucht
          </Typography>
          {searchSell.map((row) => (
            <ActivePositionItem
              isMobile={isMobile}
              icon={
                <Tooltip arrow placement="top" title="Partner wird gesucht...">
                  <SearchTwoToneIcon sx={{ verticalAlign: "bottom" }} />
                </Tooltip>
              }
              goToChat={goToChat}
              setCurrentAP={setCurrentAP}
              key={row.id}
              details={row}
            />
          ))}
          <Divider sx={{ mt: "3vh", width: "90%", mx: "5%" }} />
          <Typography variant="subtitle2" align="center" sx={{ mt: "1vh" }}>
            Partner gefunden
          </Typography>
          {matchedSell.map((row) => (
            <ActivePositionItem
              isMobile={isMobile}
              icon={
                <Tooltip arrow placement="top" title="Partner gefunden">
                  <ChatTwoToneIcon sx={{ color: "primary.main", verticalAlign: "bottom" }} />
                </Tooltip>
              }
              goToChat={goToChat}
              setCurrentAP={setCurrentAP}
              key={row.id}
              details={row}
            />
          ))}
        </Grid>
      </Grid>

      {!!currentAP && (
        <ActivePositionDialog
          goToChat={goToChat}
          handleCancel={handleCancel}
          details={currentAP}
          handleClose={() => {
            setCurrentAP(null)
          }}
        />
      )}
    </>
  )
}

export default ActivePositions
